import moment from "moment";
import {
  PREPEND_ENTRADAS,
  SET_MAX_ENTRADAS,
  APPEND_ENTRADA,
  APPEND_ADJUNTO,
  CANCEL_ADJUNTO,
  CLEAR_ADJUNTOS,
  RESET_ENTRADAS,
  CLEAR_BITACORA,
  SET_RESUMEN,
  SET_RESUMEN_PARTIDAS,
  ENTRADAS_PARTIDA_RECEIVED,
  SET_HAS_MORE_ENTRADAS,
} from "../types/entradas";

export default (state, { type, payload }) => {
  switch (type) {
    case SET_RESUMEN:
      return { ...state, resumen: payload };
    // { idPartida: brief summary } generated with the report summary.
    case SET_RESUMEN_PARTIDAS:
      return { ...state, resumen_partidas: payload };
    // Entradas of one partida (Trabajos retrasados); undefined while loading.
    case ENTRADAS_PARTIDA_RECEIVED:
      return { ...state, entradasPartida: payload };
    // false once a page comes back smaller than requested (no older entradas)
    case SET_HAS_MORE_ENTRADAS:
      return { ...state, hasMore: payload };
    case SET_MAX_ENTRADAS:
      return { ...state, max: state.max + payload };
    case APPEND_ENTRADA: {
      let entradas = state.entradas;
      if (!entradas || entradas === null) {
        entradas = [];
      }
      entradas = [...entradas];
      entradas.push(payload);
      return { ...state, entradas };
    }

    case PREPEND_ENTRADAS:
      let entradas = state.entradas;
      if (!entradas || entradas === null) {
        entradas = [];
      }
      entradas = [...entradas];
      let idEntradas = entradas.map((entrada) => entrada.idEntrada);
      if (Array.isArray(payload)) {
        let entradasToPush = payload.filter(
          (entrada) => !idEntradas.includes(entrada.idEntrada)
        );
        entradas = entradas.concat(entradasToPush);
      }
      entradas = entradas.sort((a, b) =>
        moment(a.createdAt).isAfter(moment(b.createdAt)) ? 1 : -1
      );
      return { ...state, entradas };
    case RESET_ENTRADAS:
      return { ...state, entradas: [], hasMore: true };
    case APPEND_ADJUNTO: {
      let adjuntos = state.adjuntos;
      if (Array.isArray(adjuntos)) adjuntos = [...adjuntos];
      else adjuntos = [];
      return { ...state, adjuntos: [...adjuntos, payload] };
    }
    case CANCEL_ADJUNTO:
      let adjuntos = [...state.adjuntos];
      adjuntos.splice(payload, 1);
      return { ...state, adjuntos };
    case CLEAR_ADJUNTOS:
      return { ...state, adjuntos: [] };
    case CLEAR_BITACORA:
      return { ...state, entradas: [], hasMore: true, max: 0 };
    default:
      return { ...state };
  }
};
